import ConfigOnboard from "../../components/onboarding/ConfigOnboard";
import Module from "../../components/onboarding/Module";
import PamLocalAccount from "../../components/onboarding/setups/PamLocalAccount";
import PamServiceAccount from "../../components/onboarding/setups/PamServiceAccount";
import RiskBasedMFA from "../../components/onboarding/setups/RiskBasedMFA";
import Welcome from "../../components/onboarding/Welcome";
import TenantConfig from "../../components/windows/tenantConfig";

const onboardRouter = [
  { path: "", element: <Welcome /> },
  { path: "module", element: <Module /> },
  { path: "config", element: <ConfigOnboard /> },
  { 
    path: "setup/*", children: [
        { path: "mfa", element: <RiskBasedMFA /> },
        { path: "serviceAccount", element: <PamServiceAccount /> },
        { path: "localAccount", element: <PamLocalAccount /> },
        { path: "tenantConfig", element: <TenantConfig /> },
    ] 
  }
];

export default onboardRouter;